var _circle, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#E4C1FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1414 17.5997C17.6663 19.1069 17.2774 19.9342 16.6105 20.5824C14.9828 22.1633 14.7214 22.1633 13.443 22.1633C12.1645 22.1633 11.9031 22.1633 10.2755 20.5824C9.60844 19.9342 9.21973 19.1069 8.74443 17.5997M18.1414 17.5997C18.7855 17.3626 19.25 16.6617 19.25 15.8397C19.25 15.0176 18.7855 14.3168 18.1414 14.0849M8.69181 14.0849C8.69181 14.0849 9.21973 10.6503 9.81363 10.0832C10.4075 9.5161 11.5959 10.0431 13.487 10.0431C15.1059 10.0431 16.101 9.60384 16.6105 10.0832C17.8643 11.2617 18.1414 14.0849 18.1414 14.0849M8.69181 17.5997C8.04794 17.3626 7.58337 16.6617 7.58337 15.8397C7.58337 15.0176 8.04794 14.3168 8.69181 14.0849",
    stroke: "#344266",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9772 14.2578C15.5681 14.2578 15.2382 14.6118 15.2382 15.0483C15.2382 15.4848 15.5681 15.8387 15.9772 15.8387C16.3864 15.8387 16.7163 15.4848 16.7163 15.0483C16.7163 14.6118 16.3864 14.2578 15.9772 14.2578Z",
    fill: "#344266"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8566 14.2578C11.2649 14.2578 11.5956 14.6118 11.5956 15.0483C11.5956 15.4848 11.2649 15.8387 10.8566 15.8387C10.4483 15.8387 10.1176 15.4848 10.1176 15.0483C10.1176 14.6118 10.4483 14.2578 10.8566 14.2578Z",
    fill: "#344266"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7803 18.7425C12.7303 19.7736 14.1655 19.7639 15.106 18.7188",
    stroke: "#344266",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4333 14.2332C18.4333 14.2332 19.2498 14.7865 19.2498 10.5708C19.2498 8.33121 17.3035 6.35509 13.4427 6.35509C12.6179 6.35509 10.9022 6.91499 9.74736 5.82812C9.74736 5.82812 8.46058 7.0138 8.69154 8.46295C8.69154 8.46295 6.68504 11.2918 8.24924 14.3404",
    stroke: "#344266",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaleIcon);
export default __webpack_public_path__ + "static/media/MaleIcon.4fe4dab123bdb505fa05e700bc9b9656.svg";
export { ForwardRef as ReactComponent };